import * as React from "react";

import Markdown from "components/parts/Markdown";
import { StyledTable } from "./style";

const Table = ({ data }) => {
  if (!data) return;
  return (
    <StyledTable>
      <table>
        <thead>
          <tr>
            {data[0].map(colHeader => (
              <th key={colHeader}>{colHeader}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.slice(1).map((dataRow, index) => (
            <tr key={index}>
              {dataRow.map(dataCell => (
                <td key={dataCell}>
                  <Markdown source={dataCell} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </StyledTable>
  );
};

export default Table;
